import { styled } from "@mui/material/styles";
import { Dialog, DialogTitle, IconButton, Box } from "@mui/material";

export const ModalRoot = styled(Dialog)(({ theme }) => ({
  // Estilos base del modal
  "& .MuiDialog-paper": {
    borderRadius: theme.spacing(1),
    maxWidth: "95%",
  },
}));

export const ModalTitleRoot = styled(DialogTitle)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(2),
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const ModalCloseButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.grey[500],
  "&:hover": {
    color: theme.palette.grey[700],
    backgroundColor: theme.palette.action.hover,
  },
  transition: theme.transitions.create(["color", "background-color"], {
    duration: theme.transitions.duration.shortest,
  }),
}));

export const ModalContentWrapper = styled(Box)(({ theme, hasTitle }) => ({
  paddingTop: hasTitle ? 0 : theme.spacing(1),
}));

export const ModalActionsWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`,
}));

export const ModalExampleContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const ModalExampleButtonsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  flexWrap: "wrap",
  marginBottom: theme.spacing(2),
}));

export const ModalExampleContent = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));
